import { toast } from "react-toastify";
import { getTheme } from "utils/v2/theme";

let blockToast = false; // Global flag to control toast visibility

export const setBlockToast = (value: any) => {
  blockToast = value;
};

export const canShowToast = () => {
  return !blockToast; // Return true if toasts can be shown
};

export const ToastSuccess = (message: string = "عملیات با موفقیت انجام شد") => {
  const theme = getTheme();
  return toast.success(message, {
    position: "top-right",
    closeOnClick: true,
    closeButton: false,
    style: {
      direction: "rtl",
      backgroundColor: theme === "dark" ? "#313133" : "#FFFFFF",
      borderRadius: 10,
      width: "90%",
      fontFamily: "Shabnam",
      fontWeight: "bold",
      borderRightColor: "#219653",
      borderRightWidth: "10px",
      borderRightStyle: "solid",
    },
    bodyStyle: {
      color: theme === "dark" ? "#BDBDBD" : "#828282",
      flexDirection: "row-reverse",
      textAlign: "center",
    },
    autoClose: 3500,
    hideProgressBar: true,
    icon: () => <div className="toastSuccess">✓</div>,
  });
};
export const ToastDanger = (message: string = "عملیات با موفقیت انجام نشد") => {
  const theme = getTheme();
  if (!canShowToast()) return;
  return toast.error(message, {
    toastId: message,
    position: "top-right",
    closeOnClick: true,
    closeButton: false,
    style: {
      direction: "rtl",
      backgroundColor: theme === "dark" ? "#313133" : "#FFFFFF",
      borderRadius: 10,
      width: "90%",
      fontFamily: "Shabnam",
      fontWeight: "bold",
      borderRightColor: "#ef233c",
      borderRightWidth: "10px",
      borderRightStyle: "solid",
    },
    bodyStyle: {
      color: theme === "dark" ? "#BDBDBD" : "#828282",
      flexDirection: "row-reverse",
      textAlign: "center",
    },
    autoClose: 3500,

    hideProgressBar: true,
    icon: () => <div className="toastDanger">x</div>,
  });
};
